import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Grid, Segment } from "semantic-ui-react";
import { Form as FinalForm, Field } from "react-final-form";
import CategoryList from "./CategoryList";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadComponent from "../../../app/layout/LoadComponent";
import { Link } from "react-router-dom";
import TextInput from "../../../app/common/form/TextInput";
import SelectInput from "../../../app/common/form/SelectInput";

const CategoryDashboard: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    loadCategories,
    loadingInitial,
    categoryFilter,
    setPredicate,
  } = rootStore.categoryStore;

  const [filterVisible, setFilterVisible] = useState(false);

  const sortBy = [
    { key: "", text: "", value: "" },
    { key: "name", text: "Nome", value: "name" },
    { key: "name_desc", text: "Nome Desc", value: "name_desc" },
    { key: "questioncount", text: "Questões", value: "questioncount" },
    { key: "questioncount_desc", text: "Questões Desc", value: "questioncount_desc" }
  ];

  useEffect(() => {
    loadCategories();
  }, [loadCategories]);

  if (loadingInitial)
    return <LoadComponent content="Carregando categorias..." />;

  const handleSubmitFilter = (values: any) => {
    const { ...catFilter } = values;
    categoryFilter.name = catFilter.name;
    categoryFilter.sortBy = catFilter.sortBy;
    setPredicate();
  };

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={14}>
          <h1>Categorias</h1>
        </Grid.Column>
        <Grid.Column width={2}>
          <Button
            as={Link}
            to="/admin/novacategoria"
            active
            positive
            content="Nova"
            floated="right"
            style={{ marginTop: "12px" }}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={16}>
          <Segment>
            <h2 onClick={() => setFilterVisible(!filterVisible)}>Filtros</h2>
            {(filterVisible || categoryFilter.name) && (
              <Segment>
                <FinalForm
                  initialValues={categoryFilter}
                  onSubmit={handleSubmitFilter}
                  render={({ handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                      <Form.Group>
                        <Field
                          name="name"
                          placeholder="Categoria"
                          value={categoryFilter!.name}
                          component={TextInput}
                          width={3}
                        />
                        <Field
                          component={SelectInput}
                          options={sortBy}
                          name="sortBy"
                          placeholder="Ordenar por"
                          value={categoryFilter!.sortBy}
                          width={2}
                        />
                        <Button content="Pesquisar" />
                      </Form.Group>
                    </Form>
                  )}
                />
              </Segment>
            )}
          </Segment>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={16}>
          <CategoryList />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default observer(CategoryDashboard);
